import { render, staticRenderFns } from "./EditPrintGroups.vue?vue&type=template&id=e5d779f4"
import script from "./EditPrintGroups.vue?vue&type=script&lang=ts"
export * from "./EditPrintGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports